import React, { useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Text, Heading } from 'roo-ui/components';
import TextButton from 'components/TextButton';
import Modal from 'components/Modal';
import { useModal } from 'lib/hooks';
import { useDataLayer } from 'hooks/useDataLayer';

const OfferDetails = ({ offer }) => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();
  const { name, description } = offer;

  const handleOnClick = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Summary View', value: 'Offer Details Selected' });
  }, [emitInteractionEvent, openModal]);

  return (
    <Fragment>
      <TextButton
        onClick={handleOnClick}
        color="greys.charcoal"
        hoverColor="greys.steel"
        fontSize={['sm', 'base']}
        data-testid="offer-name"
        fontWeight="bold"
        textAlign="left"
        lineHeight="normal"
      >
        {name}
      </TextButton>

      <Modal {...modalProps} title="Offer description">
        <Text display="block" mb="5" data-testid="modal-offer-description-text">
          <Heading.h4 fontSize="sm">{name}</Heading.h4>
          {description}
        </Text>
      </Modal>
    </Fragment>
  );
};

OfferDetails.propTypes = {
  offer: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};

export default OfferDetails;
